// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Helper function to handle API requests
const apiRequest = async (endpoint, options = {}) => {
  try {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    console.log(`API Request: ${config.method} ${url}`);
    
    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

// Data fetching functions
const apiService = {
  // Fetch all data in one request (most efficient)
  fetchAllData: async () => {
    const response = await apiRequest('/api/data/all');
    return response.data; // Returns { colleges, courses, fees, allotments }
  },

  // Individual data fetching functions (if needed)
  fetchColleges: async () => {
    const response = await apiRequest('/api/data/colleges');
    return response.data;
  },

  fetchCourses: async () => {
    const response = await apiRequest('/api/data/courses');
    return response.data;
  },

  fetchFees: async () => {
    const response = await apiRequest('/api/data/fees');
    return response.data;
  },

  fetchAllotments: async () => {
    const response = await apiRequest('/api/data/allotments');
    return response.data;
  },

  // Health check
  checkHealth: async () => {
    const response = await apiRequest('/health');
    return response;
  }
};

export default apiService; 